import { forwardRef, HTMLAttributes, ReactNode, useMemo, createElement } from 'react'
import classNames from 'classnames'

export type TypographyVariantsT =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'body1'
  | 'body2'
  | 'button1'
  | 'button2'
  | 'caption'
  | 'subtitle1'
  | 'subtitle2'
  | 'link'
  | 'input-label'
  | 'input-helper-text'
  | 'modal-title'

export type ColorT = 'grey' | 'darkRed' | 'white' | 'dark' | 'darkGrey' | 'lightDark' | 'violet' | 'purple'

type AlignT = 'left' | 'center' | 'right' | 'justify'

interface ITypographyProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode
  className?: string
  align?: AlignT
  variant?: TypographyVariantsT
  fontWeight?: 'bold'
  tag?: 'p' | 'span'
  color?: ColorT
}

const Typography = forwardRef<HTMLSpanElement, ITypographyProps>(
  ({ children, className, variant, fontWeight, tag = 'span', color, ...props }: ITypographyProps, ref) => {
    const computedClassName = useMemo(
      () => classNames(className, fontWeight && fontWeight, variant && variant, color && color),
      [className, fontWeight, variant, color]
    )

    const content = typeof children === 'string' ? { dangerouslySetInnerHTML: { __html: children } } : { children }

    return createElement(tag, {
      className: computedClassName,
      ...props,
      ref,
      ...content,
    })
  }
)

Typography.displayName = 'Typography'

export { Typography }
